import { notEqual } from "assert";

// Scales are disrcibed in terms of skips
// Let's take C major scale for example
// W W H W W W H in skips - 0, 1, 1, 0, 1, 1, 1
// Numbers means how much notes (not tones) we skip.

const MAJOR_PATTERN = 'W W H W W W H'
const MAJOR_SKIPS = [0, 1, 1, 0, 1, 1, 1]
const MINOR_SKIPS = [0, 1, 0, 1, 1, 0, 1]

const MAJOR_PENTATONIC_SKIPS = [0, 1, 1, 2, 1]
const MINOR_PENTATONIC_SKIPS = [0, 2, 1, 1, 2]

const MAJOR_BLUES = [0, 1, 0, 0, 2, 1]
const MINOR_BLUES = [0, 2, 1, 0, 0, 2]

const HARMONIC_MINOR = [0, 1, 0, 1, 1, 0, 2]
const MELODIC_MINOR =  [0, 1, 0, 1, 1, 1, 1]


const scalePatterns = [{
  name: 'Major',
  skips: MAJOR_SKIPS
}, {
  name: 'Minor',
  skips: MINOR_SKIPS
}, {
  name: 'Major Pentatonic',
  skips: MAJOR_PENTATONIC_SKIPS
}, {
  name: 'Minor Pentatonic',
  skips: MINOR_PENTATONIC_SKIPS
}, {
  name: 'Minor Blues',
  skips: MINOR_BLUES
}, {
  name: 'Major Blues',
  skips: MAJOR_BLUES
}, {
  name: 'Harmonic Minor',
  skips: HARMONIC_MINOR
}, {
  name: 'Melodic Minor',
  skips: MELODIC_MINOR
}]

const scales = [{
  name: 'C major / A minor',
  skips: MAJOR_SKIPS,
  startingNote: 'C',
  type: MAJOR_PATTERN,
},{
  name: 'C# major / A# minor',
  skips: MAJOR_SKIPS,
  startingNote: 'C#',
  type: MAJOR_PATTERN,
}, {
  name: 'D major / B minor',
  skips: MAJOR_SKIPS,
  startingNote: 'D',
  type: MAJOR_PATTERN,
}, {
  name: 'D# major / C minor',
  skips: MAJOR_SKIPS,
  startingNote: 'D#',
  type: MAJOR_PATTERN,
}, {
  name: 'E major / C♯ minor',
  skips: MAJOR_SKIPS,
  startingNote: 'E',
  type: MAJOR_PATTERN,
}, {
  name: 'F major / D minor',
  skips: MAJOR_SKIPS,
  startingNote: 'F',
  type: MAJOR_PATTERN,
}, {
  name: 'F# major / D# minor',
  skips: MAJOR_SKIPS,
  startingNote: 'F#',
  type: MAJOR_PATTERN,
}, {
  name: 'G major / E minor',
  skips: MAJOR_SKIPS,
  startingNote: 'G',
  type: MAJOR_PATTERN,
}, {
  name: 'G# major / F minor',
  skips: MAJOR_SKIPS,
  startingNote: 'G#',
  type: MAJOR_PATTERN,
}, {
  name: 'A major / F♯ minor',
  skips: MAJOR_SKIPS,
  startingNote: 'A',
  type: MAJOR_PATTERN,
}, {
  name: 'A# major / G minor',
  skips: MAJOR_SKIPS,
  startingNote: 'A#',
  type: MAJOR_PATTERN,
}, {
  name: 'B major / G♯ minor',
  skips: MAJOR_SKIPS,
  startingNote: 'B',
  type: MAJOR_PATTERN,
/* }, { */
/*   name: 'G major pentatonic / E minor pentatonic', */
/*   startingNote: 'G', */
/*   skips: MAJOR_PENTATONIC_SKIPS */
}]

export default scalePatterns



// WEBPACK FOOTER //
// ./src/constants/scales.js